"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XP = void 0;
const core_1 = require("../core");
class XP {
    constructor(questSdk) {
        this.addXpForUser = this.getDynamicNftFunctions().addRunningXP;
        this.getXpForUser = this.getDynamicNftFunctions().getXpForUser;
        this.getXpForUsers = this.getDynamicNftFunctions().getXpForUsers;
        this.getXpForEntity = this.getDynamicNftFunctions().getXpForEntity;
        this.getXpForEntities = this.getDynamicNftFunctions().getXpForEntities;
        this.questSdk = questSdk;
    }
    getDynamicNftFunctions() {
        if (!this.questSdk) {
            throw new Error("Invalid request. Please pass the base class in the constructor");
        }
        return new core_1.DynamicNft(this.questSdk);
    }
}
exports.XP = XP;
